import { jsx as _jsx } from "react/jsx-runtime";
import { CardContent as MuiCardContent, } from '@mui/material';
import { skipProps, styled } from '../../../utils';
export function CardContent(props) {
    const { noPadding = false, noPaddingTop = false, equalPadding = false, ...otherProps } = props;
    return (_jsx(CardContentStyled, { noPadding: noPadding, noPaddingTop: noPaddingTop, equalPadding: equalPadding, ...otherProps }));
}
const CardContentStyled = styled(MuiCardContent, {
    shouldForwardProp: skipProps([
        'noPadding',
        'noPaddingTop',
        'equalPadding',
    ]),
})(({ theme, noPadding, noPaddingTop, equalPadding }) => ({
    padding: theme.spacing(0, 2, 2),
    '&:first-of-type': {
        paddingTop: theme.spacing(2),
    },
    '&:last-of-type': {
        paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(1, 2.5, 2.5),
        '&:first-of-type': {
            paddingTop: theme.spacing(2.5),
        },
        '&:last-of-type': {
            paddingBottom: theme.spacing(2.5),
        },
    },
    ...(noPaddingTop && {
        paddingTop: 0,
    }),
    ...(equalPadding && {
        '&:first-of-type': {
            paddingTop: theme.spacing(0.5),
            paddingBottom: theme.spacing(0.5),
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(1, 2.5),
        },
    }),
    ...(noPadding && {
        padding: 0,
        '&:first-of-type': {
            padding: 0,
        },
        [theme.breakpoints.up('md')]: {
            paddingTop: 0,
        },
    }),
}));
